module.exports = __webpack_public_path__ + "static/media/height-percent.c414acbf.jpeg";